<table style="width: 100%;">
    <thead>
    <ng-content select="[thead]"></ng-content>
    </thead>
    <tbody>
    <tr *ngIf="error" class="text-center ion-margin">
        <ion-label color="danger" style="text-align: center;"> Une erreur est survenue</ion-label>
    </tr>
    <tr *ngIf="loading" class="text-center ion-margin">
        <app-loading></app-loading>
    </tr>
    <tr *ngIf="page && page.content.length == 0" class="ion-margin text-center">
    </tr>
    <ng-container *ngFor="let element of page?.content" [ngTemplateOutletContext]="{element:element}"
                  [ngTemplateOutlet]="template">

    </ng-container>
    </tbody>
    <tfoot>
    <ng-content select="[tfoot]"></ng-content>
    </tfoot>
</table>
<app-pagination [page]="page" *ngIf="page" [paginatedService]="paginatedService"></app-pagination>
